import { TextKey } from '@mews-commander/enums';
import { lockIcon, upgradedIcon, outOfOrderIcon, houseUseIcon, femaleIcon, addIcon } from '@optimus-web/assets';
import { FONT_FAMILY_INTER } from '@optimus-web/fonts';

export const TIMELINE_CANVAS_ID = 'timeline-canvas';

export const REFRESH_INTERVAL = 3 * 60 * 1000; // 3 minutes

export const MODULE_NAME = 'timeline';
export const TIMELINE_VIEW_NAME = 'timelineView';
export const RESOURCE_USE_FETCH_LOW_PADDING = 2;
export const RESOURCE_USE_FETCH_HIGH_PADDING = 3;
export const COLOR_OVERBOOKED = 'rgba(214, 56, 72, 0.15)';
export const COLOR_HIGHLIGHT = 'rgba(70, 103, 195, 0.1)';
export const COLOR_HIGHLIGHT_SELECTED = 'rgba(214, 226, 252, 1)';

export const ICON = {
    LOCK: lockIcon,
    UPGRADE: upgradedIcon,
    OUT_OF_ORDER: outOfOrderIcon,
    HOUSE_USE: houseUseIcon,
    FEMALE: femaleIcon,
    ADD: addIcon,
};

export const LABEL_PART = {
    ICON: 'stateIcon',
    TEXT: 'text',
    CUSTOMER_CLASSIFICATION: 'classification',
};

export const CURSOR = {
    MOVE: 'move',
    DRAG: 'ns-resize',
    POINTER: 'pointer',
};

export const CLASSIFICATION_WIDTH = 18;
export const CLASSIFICATION_FONT_SIZE = 16;
export const ICON_WIDTH = 22;
export const LABEL_FONT_SIZE = 14;
export const TEXT_PADDING = 5;

export const MIN_QUICK_SCROLL_HIT_TARGET_SIZE = 50;
export const QUICK_SCROLL_PADDING = 15;

export const TOOLTIP_TIMEOUT = 200;
export const HOUR_WIDTH = 94;
export const DAY_WIDTH = 150;
export const MONTH_WIDTH = 200;

export const LINE_HEIGHT = 33;
export const RESOURCE_WIDTH = 112;

export const FIRST_LINE = 22;
export const SECOND_LINE = 54;

export const RESOURCE_CATEGORY_TYPE_FONT_SIZE = 14;

export const EVENT_RADIUS = 8;
export const EVENT_BORDER_RADIUS = 10;
export const EVENT_PADDING = 7;
export const EVENT_FONT_SIZE = 12;
export const EVENT_SIZE = EVENT_BORDER_RADIUS * 2;
export const EVENT_TOP_POSITION = LINE_HEIGHT + EVENT_PADDING;
export const EVENT_BOTTOM_POSITION = EVENT_TOP_POSITION + EVENT_SIZE;

export const FONT_FAMILY = FONT_FAMILY_INTER;
export const FONT_SIZE = 13;
export const DATE_LEGENT_PARENT_FONT_SIZE = 14;
export const DATE_LEGENT_COLUMN_FONT_SIZE = 12;

export const MAX_ZOOM = 0.05;
export const MIN_ZOOM = 1;

export const PI_2 = 2 * Math.PI;

export const KEYBOARD_MOVE_SPEED = 2000;
export const AUTO_DRAG_SPEED = 1200;

export const INITIAL_DESKTOP_OFFSET = -3;
export const INITIAL_MOBILE_OFFSET = -1;

export const LABEL_SCALE_BREAKPOINT = 0.5;
export const SPACE_LINE_BREAKPOINT = 0.1;

export const LONG_PRESS_THRESHOLD = 300;

export const DATE_LEGEND_ROW_COUNTS = 2;
export const DATE_LEGEND_HEIGHT = LINE_HEIGHT * DATE_LEGEND_ROW_COUNTS;

export const SIMPLE_DETAIL_SCOPE = 'timeline-simple-detail-scope';

export const CORNER_RADIUS = 4;

export const TIMELINE_FILTER_EVENT_CATEGORY = 'Timeline filter';
export const TIMELINE_HEADER_EVENT_CATEGORY = 'Timeline header';
export const TIMELINE_DATE_LEGEND_EVENT_CATEGORY = 'Timeline date legend';

export const RESOURCE_LEGEND_MIN_WIDTH = 286;

export const DATE_LEGEND_PARTS = {
    PARENT_UNIT: 'parent-unit',
    COLUMN_UNIT: 'column-unit',
};
export const RESOURCE_LIMIT_FOR_COMPACT_VIEW = 200;

export const DENSITY = {
    SPACIOUS: 'spacious',
    COMPACT: 'compact',
    DENSE: 'dense',
};

export const DENSITY_TEXT_KEYS = {
    [DENSITY.COMPACT]: TextKey.TimelineDensityScaleComfortable,
    [DENSITY.DENSE]: TextKey.TimelineDensityScaleCompact,
    [DENSITY.SPACIOUS]: TextKey.TimelineDensityScaleDefault,
};

export const DENSITY_ZOOM_VALUE = {
    [DENSITY.COMPACT]: 0.65,
    [DENSITY.DENSE]: MAX_ZOOM,
    [DENSITY.SPACIOUS]: MIN_ZOOM,
};

export const DENSITY_PERCENTAGE = {
    '10': 0.1,
    '30': 0.3,
    '50': 0.5,
    '70': 0.7,
    '90': 0.9,
    '100': 1,
};

export const HOUSE_USE_MONTHLY_VIEW_LIMIT = 12;
